export default {
  title: 'Interview Criteria Management',
  menu: 'Interview Criteria Management',
  label: {
    company: 'Company',
    groupName: 'Group',
    criteria: 'Criteria',
    status: 'Status',
    activeCategory: 'Enabled Groups',
    inactiveCategory: 'Disabled Groups',
    categoryTitle: 'Group Name',
    addCategory: 'Add Group',
    editCategory: 'Edit Group',
    addQuestion: 'Add New Interview Criteria',
    editQuestion: 'Edit New Interview Criteria',
    content: 'Content'
  },
  btn: {
    addQuestion: 'Add New Interview Criteria',
    addCategory: 'Add Group'
  },
  placeholder: {
    categoryStatus: 'All Groups',
    keywords: 'Search by group',
    categoryTitle: 'Please select group',
    categoryExist: 'Group title already exists',
    content: 'Please Input Content',
    groupName: 'Please Select Group'
  }
}
